<template>
    <BaseModal ref="modal" v-model="modalShow" size="xl">
        <DocumentPdf :pdfUrl="pdfUrl"></DocumentPdf>
    </BaseModal>
</template>
<script>
import { EventNames } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import DocumentPdf from '@/components/shared/Document-pdf.vue'
import BaseModal from '@/components/shared/Base-modal.vue';

export default {
    name: 'KarinDocument',

    data() {
        return {
            modalShow: false,
            route: '',
            pdfUrl: '',
        }
    },

    components: {
        DocumentPdf,
        BaseModal
    },

    async mounted() {
        this.$eventBus.$on(EventNames.OpenModalKarinDocumentLink, async (query) => {
            this.reset();
            this.route = query;
            this.modalShow = true;
            await this.getDocumentUrl();
            if (!this.pdfUrl) {
                this.modalShow = false;
            }
        });
    },

    methods:{
        ...mapActions(["getKarinDocumentUrl"]),

        async getDocumentUrl() {
            let result = await this.getKarinDocumentUrl({ route: this.route });

            if (result.isError) {
                this.$refs.modal.showAlertExternal(result.message, 'danger');
                return;
            }

            this.pdfUrl = result.data;
        },

        reset() {
            this.route = '';
            this.pdfUrl = '';
        }
    }
}</script>
